import React from "react";
import PropTypes from "prop-types";
import { Stack, Typography } from "@mui/material";
import { Icon } from "@iconify/react";

export default function InfoRow({ icon, text, bold = false }) {
  if (!text) return null;

  return (
    <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
      <Icon icon={icon} width={18} />
      <Typography
        variant="body2"
        sx={{
          fontWeight: bold ? 600 : 400,
          minWidth: 0,
          overflowWrap: "anywhere",
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
}

InfoRow.propTypes = {
  icon: PropTypes.string.isRequired,
  text: PropTypes.string,
  bold: PropTypes.bool,
};

InfoRow.defaultProps = {
  text: "",
  bold: false,
};
